module.exports = __webpack_public_path__ + "img/woman-head-back.7c2c6401.png";